 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		13: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		13: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"a6e3d24a0905eaf3713985fce0e0774ece454f48","1":"styles","2":"fe6786e0cf602a6e0d576f925f7eb26d68cb377e","3":"99222ee174407e542315ca851697792e928b1a57","4":"2e02b35f642a79d4d22347d6c8a94c26ad517338","5":"4ea5401a6bb3e4f838ebffef66bf9cc7b25fe69a","6":"95b98745c7115a4e6236ad090c96001665718c45","7":"5975222108eeb9452e2e273a6e816e4ba2558862","8":"97a3dd426c69d16cade2ea8654bf700f15edc053","9":"c8f7fe3b0e41be846d5687592cf2018ff6e22687","10":"ea88be26","11":"eb47b0954ebf41cae579898d559145be431de215","12":"framework","15":"6de13d4a","17":"component---src-pages-404-jsx","18":"component---src-pages-templates-blog-blog-entry-page-jsx","19":"component---src-pages-templates-complex-page-jsx","20":"component---src-pages-templates-contact-page-jsx","21":"component---src-pages-templates-home-page-jsx","22":"component---src-pages-templates-know-us-page-jsx","23":"component---src-pages-templates-news-news-entry-archive-page-jsx","24":"component---src-pages-templates-news-news-entry-page-jsx","25":"component---src-pages-templates-partner-page-jsx","26":"component---src-pages-templates-press-press-entry-archive-page-jsx","27":"component---src-pages-templates-press-press-entry-page-jsx","28":"component---src-pages-templates-prismic-preview-page-jsx","29":"component---src-pages-templates-product-page-jsx","30":"component---src-pages-templates-redirect-redirect-page-jsx","31":"component---src-pages-templates-resellers-page-jsx","32":"component---src-pages-templates-sector-page-jsx","33":"component---src-pages-templates-simple-page-jsx","34":"component---src-pages-templates-solution-page-jsx","35":"component---src-pages-templates-use-case-archive-page-jsx","36":"component---src-pages-templates-use-case-page-jsx","37":"component---src-pages-templates-white-paper-archive-page-jsx","38":"components-AuroraDiagramAnimation","39":"components-DiagramAnimation"}[chunkId]||chunkId) + "-" + {"0":"e766f12a22fd0a3562f7","1":"136dffcde22e5b1103b3","2":"d98fdd88242555790a40","3":"f3869e2dbbc16f8a4885","4":"fa1f76eb520213f3b411","5":"ec3fdd50a1bfe28af7e3","6":"4f523bf1243738ee296e","7":"7873bdcbf38882ef6198","8":"39f1feab9c0e59e475c7","9":"f57803c6de487c57b39c","10":"15b3f0e715597822aab2","11":"0b7d908bc64b434e184c","12":"27482fa96d0d88e17426","15":"6b032266fd4ff11d93a4","17":"08038686b92aa8798f87","18":"64c64a789bd5bb2e8857","19":"c907625e71e0790a4681","20":"f5c888b24b6be677ae9a","21":"244086860a2aa0a9b8df","22":"6410026cfbacdfc641a4","23":"60d7d1f45dca8960fd52","24":"93070f1dfdd7b2af7f0a","25":"0eae89f66bd0188b6a1f","26":"5a93a5f1a557e48854a1","27":"ebe1c29957d6d74c60e7","28":"1f8d12c7bd5a8134c714","29":"8711ca7b495f13906606","30":"847194e5843e1d9b132a","31":"66764505d8cc28c0a0f0","32":"82ba7f6c3b30cfa22811","33":"85376c86bbd319ddb426","34":"4508ad582b35d5f69d1c","35":"f337a7c2032c9f773ab6","36":"0c64890d8e41bef007c9","37":"edfa53825966b1e6534a","38":"c5e4e08eb799ddb6c1dc","39":"bb54ae4ef89faff42e69","41":"6ff2b1588802f6359938","42":"15d2d413fca086ebd58b","43":"ebcd4414d6fcb202c17c","44":"a76001481bd1f183043f","45":"0a942cf4cad4770822c2","46":"d21a09d06fc314605482","47":"d5f20ff69094228678bf","48":"89221dece9fb0f9e9713","49":"6f49a7026e9c1cc72530"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"a6e3d24a0905eaf3713985fce0e0774ece454f48","1":"styles","2":"fe6786e0cf602a6e0d576f925f7eb26d68cb377e","3":"99222ee174407e542315ca851697792e928b1a57","4":"2e02b35f642a79d4d22347d6c8a94c26ad517338","5":"4ea5401a6bb3e4f838ebffef66bf9cc7b25fe69a","6":"95b98745c7115a4e6236ad090c96001665718c45","7":"5975222108eeb9452e2e273a6e816e4ba2558862","8":"97a3dd426c69d16cade2ea8654bf700f15edc053","9":"c8f7fe3b0e41be846d5687592cf2018ff6e22687","10":"ea88be26","11":"eb47b0954ebf41cae579898d559145be431de215","12":"framework","15":"6de13d4a","17":"component---src-pages-404-jsx","18":"component---src-pages-templates-blog-blog-entry-page-jsx","19":"component---src-pages-templates-complex-page-jsx","20":"component---src-pages-templates-contact-page-jsx","21":"component---src-pages-templates-home-page-jsx","22":"component---src-pages-templates-know-us-page-jsx","23":"component---src-pages-templates-news-news-entry-archive-page-jsx","24":"component---src-pages-templates-news-news-entry-page-jsx","25":"component---src-pages-templates-partner-page-jsx","26":"component---src-pages-templates-press-press-entry-archive-page-jsx","27":"component---src-pages-templates-press-press-entry-page-jsx","28":"component---src-pages-templates-prismic-preview-page-jsx","29":"component---src-pages-templates-product-page-jsx","30":"component---src-pages-templates-redirect-redirect-page-jsx","31":"component---src-pages-templates-resellers-page-jsx","32":"component---src-pages-templates-sector-page-jsx","33":"component---src-pages-templates-simple-page-jsx","34":"component---src-pages-templates-solution-page-jsx","35":"component---src-pages-templates-use-case-archive-page-jsx","36":"component---src-pages-templates-use-case-page-jsx","37":"component---src-pages-templates-white-paper-archive-page-jsx","38":"components-AuroraDiagramAnimation","39":"components-DiagramAnimation"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"dae35acd145852ba0314","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
